
































































































import userService from '@/services/user.service';
import { Device, Position, User } from '@/types';
import { Getter } from 'vuex-class';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import ConfirmButton from '../ConfirmButton.vue';
import taskService from '@/services/task.service';

@Component({
  components: {
    Dialog,
    ConfirmButton,
  },
})
export default class CreateTaskForPositionsDialog extends Vue {
  @Prop({ default: () => []}) private positions!: Position[];
  @Prop({ default: false }) private show!: boolean;

  private readonly taskTypes = [
    {value: 'install', text: 'Install a device'},
    {value: 'repair', text: 'Repair a device'},
    {value: 'replace', text: 'Swap a device'},
    {value: 'battery', text: 'Replace a battery'},
    {value: 'recall', text: 'Uninstall a device'},
  ];

  private taskType: string | null = null;
  private assignee: User | null = null;
  private dueAt: Date | null = null;
  private loading: boolean = false;
  private openDatePicker: boolean = false;
  private usersSearch: string = '';
  private notes: string = '';

  private users: User[] = [];

  private now = new Date().toISOString().substr(0, 10);

  private async mounted() {
    this.loading = true;
    try {
      await this.populateUsers();
    } finally {
      this.loading = false;
    }
  }

  private async populateUsers() {
    const { users } = await userService.getUsersForOrganisation();
    this.users = users;
  }

  private get allowedTaskTypes() {
    const allHaveDevices = this.positions.every((position) => position.device_id || position.device);
    return this.taskTypes.filter((type) => {
      return type.value === 'install' ? !allHaveDevices : allHaveDevices;
    });
  }

  private get formattedUsersList(): any[] {
    return this.users.map((user: any) => ({
      text: `${user.first_name} ${user.last_name} (${user.email})`,
      value: user.id,
    }));
  }

  private get canSave() {
    return !!this.taskType;
  }

  private async save() {
    this.loading = true;
    try {
      const saving = await Promise.all(this.positions.map((position) => {
        return taskService.createTask({
          type: this.taskType,
          position_id: position.id,
          project_id: position.project_id || null,
          assigned_user_id: this.assignee ? this.assignee : null,
          due_at: this.dueAt,
          task_note: this.notes || null,
        });
      }));
    } finally {
      this.loading = false;
      this.$emit('finished');
    }
  }

  @Watch('show', { immediate: true })
  private handleShowChange(value: boolean) {
    this.assignee = null;
    this.dueAt = null;
    this.notes = '';
    this.taskType = null;

    if (this.allowedTaskTypes.length === 1) {
      this.taskType = this.allowedTaskTypes[0].value;
    }
  }
}
